import React, { Component } from 'react';
import '../App.css';
import logo from '../images/face_small.jpg';
import {Link} from 'react-router-dom';
import autosize from 'autosize';
/* global moment */
/* global $ */

export default class ViewBlog extends Component {
  constructor(props){
    super(props);
    this.state = {
      'full_post': {},
      'full_post_loaded': false,
      'report_cid': '',
      'report_c_type': '',      
    };
  }
  
  
  save_com(parent_type, parent_com_id, com_id) {
    let firebase = this.props.app_state.firebase;
    let this_user = this.props.app_state.this_user;
    if (this_user === null) {
      return $('#alert_danger').text('Please log in first').fadeIn().delay(1500).fadeOut();
    }
    
    let comment_id = 'bc_'+Date.now()+'_'+Math.floor(Math.random()*1000);
    let blog_id = window.location.pathname.split('/')[2];
    let temp_comment = {
      'id': comment_id,
      'author': this_user.id,
      'author_name': this_user.name,
      'reply_to_type': parent_type,
      'num_likes': 0,
      'pub_time': Date.now(),
      'post_id': blog_id,
      'post_title': this.state.full_post.title,
    };
    let for_db = {};
    
    if (parent_type === 'blog') {
      temp_comment['reply_to'] = blog_id;
      
      let content = $('#new_com_text').val();
      if (content.replace(/\s/g, '') === ''){
        return $('#alert_danger').text('Comment is empty').fadeIn().delay(1500).fadeOut();
      }
      
      
      for_db['/blog_posts/'+blog_id+'/comments/'+comment_id] = temp_comment;
      for_db['/blog_posts/'+blog_id+'/comments/'+comment_id]['content'] = $('#new_com_text').val();
      console.log(for_db);
      $('#new_com_text').val('');
      $('#new_com_text').animate({'height': '62px'}, 400 );
      firebase.database().ref('/main').update(for_db)
        .then(() => {
          $('#alert_dark').text('Comment Posted').fadeIn().delay(1200).fadeOut();
        })
        .catch((error) => {
          $('#alert_danger').text(error.message).fadeIn().delay(3000).fadeOut();
        });
    }
    else if (parent_type === 'blog_comment') {
      temp_comment['reply_to'] = parent_com_id;
      
      let content = $('#new_com_'+com_id).val();
      if (content.replace(/\s/g, '') === ''){
        return $('#alert_danger').text('Comment is empty').fadeIn().delay(1500).fadeOut();
      }

      
      for_db['/blog_posts/'+blog_id+'/comments/'+parent_com_id+'/comments/'+comment_id] = 
                                                                                        temp_comment;
      for_db['/blog_posts/'+blog_id+'/comments/'+parent_com_id+'/comments/'+comment_id]['content'] = 
                                                                                             content;
      console.log(for_db);
      $('#new_com_cont_'+com_id).fadeOut();
      $('#new_com_'+com_id).val('').css({'height': '62px'});
      firebase.database().ref('/main').update(for_db)
        .then(() => {
          $('#alert_dark').text('Comment Posted').fadeIn().delay(1200).fadeOut();
        })
        .catch((error) => {
          $('#alert_danger').text(error.message).fadeIn().delay(3000).fadeOut();
        });
    }
  }
  confirm_report_comment() {
    let firebase = this.props.app_state.firebase;
    
    if ($('#report_com_message').val() === '') {
      $('#alert_danger').text('Please add a message').fadeIn().delay(2000).fadeOut();
      return;
    }
    
    let for_db = {};
    for_db['reporter'] = (this.props.app_state.this_user||{}).id;
    for_db['reporter_name'] = (this.props.app_state.this_user||{}).name;
    for_db['type'] = this.state.report_c_type;
    for_db['reported_id'] = this.state.report_cid;
    for_db['reported_time'] = Date.now();
    for_db['comment'] = $('#report_com_message').val();
    let rep_id = 'r_'+Date.now()+'_'+Math.floor(Math.random() * 1000);
    for_db['id'] = rep_id;
    firebase.database().ref('/main/reports/'+rep_id).update(for_db)
      .then(() => {
        $('#alert_dark').text('Report Submitted').fadeIn().delay(1500).fadeOut();
        $('#report_comment').modal('hide');
        $('#report_com_message').val('');
      })
      .catch((error) => {
        $('#alert_danger').text(error.message).fadeIn().delay(3000).fadeOut();        
      });    
  }
  
  
  bookmark (saved) {
    let firebase = this.props.app_state.firebase;
    
    if (!this.props.app_state.this_user_loaded)
      return;
    let this_user = this.props.app_state.this_user;
    let for_state = {};
    let bid = window.location.pathname.split('/')[2];
    
    if (!saved) {
      // save this post in bookmarks
      for_state[this_user.id+'/blog_bookmarks/'+bid+'/post_id'] = bid;
      for_state[this_user.id+'/blog_bookmarks/'+bid+'/time'] = Date.now();
      for_state[this_user.id+'/blog_bookmarks/'+bid+'/type'] = 'blog';
      firebase.database().ref('/main/users').update(for_state)
        .then(() => {
          $('#alert_dark').text('Blog post bookmarked').fadeIn().delay(1500).fadeOut();          
        })
        .catch((error) => {
          $('#alert_danger').text(error.message).fadeIn().delay(3000).fadeOut();
        });
    }
    else {
      // remove from user bookmarks
      for_state[this_user.id+'/blog_bookmarks/'+bid] = null;
      firebase.database().ref('/main/users').update(for_state)
        .then(() => {
          $('#alert_dark').text('Bookmark removed').fadeIn().delay(1500).fadeOut();          
        })
        .catch((error) => {
          $('#alert_danger').text(error.message).fadeIn().delay(3000).fadeOut();
        });
    }    
  }
  
  componentDidUpdate() {
    autosize($('textarea'));    
  }
  
  componentDidMount() {    
    let firebase = this.props.app_state.firebase;
    
    window.scrollTo(0, 0);
    
    let post_id = window.location.pathname.split('/')[2];
    let db = firebase.database().ref('main/blog_posts/'+post_id);
    db.on('value', (snap) => {
      
      this.setState({'full_post': snap.val(),
                      'full_post_loaded': true});
    });    
    console.log('mount page', window.location.pathname)
    autosize($('textarea'));
  }
  
  render() {
    let bid = window.location.pathname.split('/')[2];
    let this_blog = this.props.app_state.blogs_dict[bid];
    
    
    if (typeof this_blog === 'undefined')
      if (this.props.app_state.blogs_loaded)
        return <h3>Blog post not found</h3>;
      else
        return <h3 className="text-muted">Loading...</h3>
    
    let blog_list = [];
    let last_index = 0;
    this_blog.images.forEach((img) => {
      blog_list.push(
        <p>{this_blog.text.slice(last_index, img.position)}</p>
      );
      blog_list.push(
        <img src={img.url} />
      );
      last_index = img.position;
    });
    blog_list.push(
      <p>{this_blog.text.slice(last_index)}</p>
    );
    
    
    let bookmark_btn = null;
    if (this.props.app_state.this_user) {
      let user_bookmarks = [];
      let mark_dict = this.props.app_state.this_user.blog_bookmarks||{};
      for (let mark_key in mark_dict) {
        user_bookmarks.push(mark_dict[mark_key].post_id);
      }
      if (!user_bookmarks.includes(bid)) {
        bookmark_btn = <button id="bookmark_btn"
                                onClick={this.bookmark.bind(this, false)} 
                                className="btn btn-outline-dark">
            Bookmark
            <i className="material-icons">bookmark_border</i>
          </button>
      }
      else {
        bookmark_btn = <button id="bookmark_btn"
                                onClick={this.bookmark.bind(this, true)} 
                                className="btn btn-dark">
            Saved
            <i className="material-icons">bookmark</i>
          </button>
      }
    }
    
    
    // make comments  
    let make_comment = <div className="new_com_div">
      <t onClick={e=>$('#login_modal').modal('show')}
          className="login_to_comment">
        Login to Comment
      </t>
    </div>;
    
    if(this.props.app_state.this_user !== null) {
      make_comment = <div className="new_com_div">
        <textarea placeholder="Join discussion..."
                  className="form-control"
                  id="new_com_text"/>
        <div id="new_com_btns">  
          <button className="btn btn-dark"
                  onClick={this.save_com.bind(this, 'blog')}>Post</button>
          <button className="btn btn-outline-danger"
                  onClick={e => {$('#new_com_text').val('');
                                 $('#new_com_text').animate({'height': '62px'}, 400 )}}>
            Cancel
          </button>
        </div>
      </div>;
    }
    
    // comments
    let comments_xml_list = [];
    if (this.state.full_post_loaded 
          && typeof (this.state.full_post||{}).comments !== 'undefined') {
      let comments = this.state.full_post['comments'];
      let com_author_name;
      let comments2;
      let comment_list = [];
      for (let cid in comments) { 
        comment_list.push(comments[cid]);
      }
      comment_list.sort((a, b) => {
        return a.pub_time - b.pub_time;
      });
      
      comment_list.forEach((this_comment) => {
        let cid = this_comment.id;
        com_author_name = this_comment.author_name || this_comment.author;
        
        /*        
            <div className={("comment_group "+(this.comment_liked.call(this, cid)?'liked':''))}
                  onClick={this.like_comment.bind(this, cid, this_comment.num_likes, 'post', post_id)}>
              <i className="material-icons">
                {(this.comment_liked.call(this, cid)?'favorite':'favorite_border')}
              </i>
              <t>{this_comment.num_likes||0}</t>
            </div>        
                <div className={("comment_group "+(this.comment_liked.call(this, cid2)?'liked':''))}
                      onClick={this.like_comment.bind(this, cid2, this_comment2.num_likes, 'comment', cid)}>
                  <i className="material-icons">
                    {(this.comment_liked.call(this, cid2)?'favorite':'favorite_border')}
                  </i>
                  <t>{this_comment2.num_likes||0}</t>
                </div>
        */
        
        comments_xml_list.push(<div className="row">
          <div className="com_img_cont">
            <Link to={"/user/"+this_comment.author}>
              <img src={logo} className="com_img" alt="logo" />
            </Link>
          </div>
          <div className="com_content_cont">
            <Link to={"/user/"+this_comment.author} className="com_author">{com_author_name}</Link>
            <p className="com_content">{this_comment.content}</p>            
            
            <t className="com_time_reply">
              <t id="reply_link"
                  onClick={e => $('#new_com_cont_'+cid).fadeIn()}>
                <i className="material-icons">reply</i>Reply
              </t>
              
              <i className="material-icons">access_time</i>
              {moment(this_comment.pub_time).fromNow()}
              
              <t className="com_report"
                  onClick={(e) => {
                    $('#report_comment').modal('show');
                    this.setState({'report_c_type': 'blog_comment',
                                    'report_cid': cid,
                                    'report_c_content': this_comment.content});
                  }}>
                <i className="material-icons">priority_high</i>
                Report
              </t>
            </t>
            <div id={"new_com_cont_"+cid} className="nested_com_cont">
              <textarea placeholder="Reply..."
                className="form-control"
                id={"new_com_"+cid}/>
              <button className="btn btn-dark"
                      onClick={this.save_com.bind(this, 'blog_comment', cid, cid)}>Post</button>
              <button className="btn btn-outline-danger"
                      onClick={e => {$('#new_com_cont_'+cid).fadeOut();
                                      $('#new_com_'+cid).val('')
                                            .css({'height': '62px'})}}>
                Cancel
              </button>
            </div>
            <hr/>
          </div>
        </div>);
        
        if (typeof this_comment['comments'] !== 'undefined') {
          comments2 = this_comment['comments'];
          
          let comment_list2 = [];
          for (let cid2 in comments2) { 
            comment_list2.push(comments2[cid2]);
          }
          comment_list2.sort((a, b) => {
            return a.pub_time - b.pub_time;
          });
          
          comment_list2.forEach((this_comment2) => {
            let cid2 = this_comment2.id;
            com_author_name = this_comment2.author_name || this_comment2.author;
              
            comments_xml_list.push(<div className="row nested_comment">
              <div className="com_img_cont">
                <Link to={"/user/"+this_comment2.author}>
                  <img src={logo} className="com_img" alt="logo" />
                </Link>
              </div>
              <div className="com_content_cont">
                <Link to={"/user/"+this_comment2.author} className="com_author">{com_author_name}</Link>
                <p className="com_content">{this_comment2.content}</p>
                
                
                <t className="com_time_reply">                  
                  <t id="reply_link"
                      onClick={e => $('#new_com_cont_'+cid2).fadeIn()}>
                    <i className="material-icons">reply</i>Reply
                  </t>
                  
                  <i className="material-icons">access_time</i>
                  {moment(this_comment2.pub_time).fromNow()}
                  
                  <t className="com_report"
                    onClick={(e) => {
                      $('#report_comment').modal('show');
                      this.setState({'report_c_type': 'nested_blog_comment',
                                      'report_cid': cid2,
                                      'report_c_content': this_comment2.content});
                    }}>
                  <i className="material-icons">priority_high</i>
                  Report
                </t>
                </t>
                <div id={"new_com_cont_"+cid2} className="nested_com_cont">
                  <textarea placeholder="Reply..."
                    className="form-control"
                    id={"new_com_"+cid2}/>
                  <button className="btn btn-dark"
                          onClick={this.save_com.bind(this, 'blog_comment', cid, cid2)}>Post</button>
                  <button className="btn btn-outline-danger"
                          onClick={e => {$('#new_com_cont_'+cid2).fadeOut();
                                         $('#new_com_'+cid2).val('')
                                            .css({'height': '62px'});}}>
                    Cancel
                  </button>
                </div>
                <hr/>
              </div>
            </div>);
          });
        }        
      });
    }
    
    let comments_xml = <div>
      {comments_xml_list}
    </div>;
    
    /*
        <h3 id="blog_leave_reply">Leave a Reply</h3>
        <hr/>
        <br/>*/
    return (
      <div id="viewblog_div" className="">
        <h1>{this_blog.title}</h1>
        <hr/>
        <t id="viewblog_time">{moment(this_blog.pub_time).format('MMMM Do, YYYY')}</t> /
        <Link to={'/user/'+this_blog.author} id="viewblog_uname">
          {this_blog.author_name}
        </Link> /
        <Link to='/blog' id="viewblog_blog">Blog</Link>
        <hr/>
        <div id="viewblog_content">
          {blog_list}
        </div>
        
        {bookmark_btn}
        
        <h3 id="blog_leave_reply">Leave a Reply</h3>
        <hr style={{'margin': '0'}}/>
        <br/>
        
        {make_comment}
        {comments_xml}
        
        
        <div id="report_comment" className="modal fade" tabindex="-1" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">What's wrong?</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal_body">
              <strong>You are about to report this comment</strong>:<br/>
              <em>"{(this.state.report_c_content||'').substring(0, 100)+'...'}"</em><br/>
              <strong>Say why</strong>:
              <textarea id="report_com_message" 
                          className="form-control"
                          placeholder="Message...">
              </textarea>
            </div>
            
            <div style={{'margin-top': '20px'}} className="modal-footer">
              <button onClick={this.confirm_report_comment.bind(this)} type="button" className="btn btn-dark">Confirm</button>
              <button type="button" className="btn btn-outline-danger" data-dismiss="modal">Cancel</button>
            </div>
          </div>
        </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ViewBlog.js